var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vTitle"}},[_c('table',{staticClass:"ncut-page-title",staticStyle:{"margin-top":"0px"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"ncut-page-title-text",staticStyle:{"text-align":"left"}},[_c('i',{staticClass:"el-icon-star-off"}),_c('span',[_vm._v(_vm._s(_vm.pageTitle))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261cc0ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitlePage.vue
// module id = null
// module chunks = 